/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvdWktZWxlbWVudC9tZXNzZW5nZXIvbWVzc2VuZ2VyLWRlbW8uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC91aS1lbGVtZW50L21lc3Nlbmdlci9tZXNzZW5nZXItZGVtby5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/ui-element/messenger/messenger-demo.component.scss.shim.ngstyle.ts